import React from "react";

interface ThemeContextType {
  theme: "light" | "dark";
  toggleTheme: () => void;
}

let ThemeContext = React.createContext<ThemeContextType>(null!);

function useTheme() {
  return React.useContext(ThemeContext);
}

export { ThemeContext, useTheme };
